import { useNavigate } from "react-router-dom";
import { ArrowLeft, BarChart3 } from "lucide-react";
import AdminDashboard from "@/components/AdminDashboard";

// Dedicated, bookmarkable, admin-only analytics page (cheapifydealdash.com/admin).
// Consolidates every owner metric + control in one full-width place — best on desktop.
export default function AdminAnalytics() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900" data-testid="admin-analytics-page">
      <header className="sticky top-0 z-20 border-b border-gray-200 bg-white pt-[env(safe-area-inset-top)]">
        <div className="mx-auto flex max-w-5xl items-center gap-3 px-4 md:px-8 h-14">
          <button
            onClick={() => navigate("/app")}
            data-testid="analytics-back-btn"
            className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 px-3 h-9 text-xs font-bold uppercase tracking-[0.06em] text-gray-600 transition-colors hover:bg-gray-100"
          >
            <ArrowLeft className="h-4 w-4" /> Back to App
          </button>
          <div className="ml-1 flex items-center gap-2">
            <BarChart3 className="h-5 w-5 text-brand-orange" />
            <span className="text-lg font-bold tracking-tighter">Owner Analytics</span>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 md:px-8 pb-24 pt-4">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-orange">Private Dashboard</p>
        <h1 className="mt-2 text-3xl md:text-4xl font-bold tracking-tighter">All Your Metrics, One Place</h1>
        <p className="mt-2 text-sm text-gray-500">Sign-up sources & emails, real e-commerce metrics, live user activity, and system health — visible only to you.</p>

        <AdminDashboard />
      </main>
    </div>
  );
}
